// @flow
import {createContext} from 'react';
import type {AbacusEvaluatedTests} from '../../types';

export type ExperimentContextValue = AbacusEvaluatedTests;

const ExperimentContext = createContext<ExperimentContextValue>({});

export default ExperimentContext;
